import { useTranslation } from "react-i18next";

import { Bar, CartesianGrid, ComposedChart, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

export default function ProfitBarChart({ data }) {
	const { t } = useTranslation("marketplace");
	function getWeekDates(year, weekNumber) {
		const januaryFirst = new Date(year, 0, 1);
		const daysToFirstDay = (weekNumber - 1) * 7;

		januaryFirst.setDate(januaryFirst.getDate() + daysToFirstDay);

		const dayOfWeek = januaryFirst.getDay();

		const startDate = new Date(januaryFirst);
		startDate.setDate(januaryFirst.getDate() - dayOfWeek);

		const endDate = new Date(startDate);
		endDate.setDate(startDate.getDate() + 7);

		const startMonth = startDate.toLocaleString("en-US", { month: "long" });
		const endMonth = endDate.toLocaleString("en-US", { month: "long" });

		const result = `${startMonth} ${startDate.getDate()} - ${endMonth} ${endDate.getDate()}`;

		return result;
	}

	function CustomTooltip({ payload, label, active }) {
		if (active && label) {
			const [year, weekNo] = label.split("-").map(Number);
			return (
				<div
					className="custom-tooltip"
					style={{ background: "#FFFFFF", padding: "3px", border: "0.2px solid grey" }}
				>
					<p className="label" style={{ marginBottom: "8px" }}>{`${getWeekDates(year, weekNo)}`}</p>
					<p style={{ margin: "2px", color: "#2521E8" }}>
						{t("marketplace_user_stats_bar_chart_gains")} : {`${payload[0].value}`}
					</p>
					<p style={{ color: "#808080" }}>
						{t("marketplace_user_stats_bar_chart_losses")} : {`${payload[1].value}`}
					</p>
				</div>
			);
		}

		return null;
	}

	return (
		<div style={{ width: "100%", height: 600 }}>
			<ResponsiveContainer>
				<ComposedChart data={data} margin={{ top: 20, right: 20, bottom: 20, left: 20 }}>
					<XAxis dataKey="label" tickLine={false} axisLine={false} />
					<YAxis yAxisId="left" tickCount={10} tickLine={true} axisLine={true} minTickGap={10} />
					<Tooltip content={<CustomTooltip />} cursor={{ fill: "transparent" }} />
					<Legend />
					<CartesianGrid stroke="#f5f5f5" vertical={false} />
					<Bar
						yAxisId="left"
						name={t("marketplace_user_stats_bar_chart_gains")}
						dataKey="profitSum"
						barSize={20}
						fill="#2521E8"
					/>
					<Bar
						yAxisId="left"
						name={t("marketplace_user_stats_bar_chart_losses")}
						dataKey="lossSum"
						barSize={20}
						fill="#808080"
					/>
				</ComposedChart>
			</ResponsiveContainer>
		</div>
	);
}
